<cds-textfield [ngClass]="disable ? 'disabled' : ''" [placeholder]="placeholder" [formControl]="formControl" [disabled]="disable" [type]="type"></cds-textfield>
